<template>
<div>
  <header>
    <h4>Process</h4>
  </header>
  <div class="timeline">
    <div class="wrap">
    <header>
      <span>Conception</span>
      <span class="spacer">
      </span>
      <span>Completion</span>
    </header>
    <ul>
      <li v-for="(item, index) in items" :key="index">
        <span>{{item.step}}</span>
        <div class="detail">
        <div class="step" v-for="s in item.steps" :key="s">{{s}}</div>
        </div>
      </li>
    </ul>
    <footer>
      <span>Abstract</span>
      <span class="spacer"></span>
      <span>Concrete</span>
    </footer>
  </div>
  </div> <!-- end wrap -->
</div>
</template>

<script>
export default {
  name: "timeline",
  data() {
    return {
      items: [
        {
          step: "01",
          steps: ["User Needs", "Business Objectives"]
        },
        {
          step: "02",
          steps: ["Functional Specs.", "Content Requirements"]
        },
        {
          step: "03",
          steps: ["Interaction Design", "Information Arch."]
        },
        {
          step: "04",
          steps: ["Interface Design", "Navigation Design", "Information Design"]
        },
        {
          step: "05",
          steps: ["Visual Design"]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
header {
  margin-bottom: 56px;
  margin-top: 56px;
  h4 {
    margin: 0;
    display: block;
    text-align: center;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.87);
    font-family: Archia;
    font-size: 12.19px;
    font-weight: 500;
    letter-spacing: 2px;
    line-height: 16px;
    position: relative;
    &:after {
      content: '';
      display: inline-block;
      width:calc(100vw - (50% + 43px));
      height: 1px;
      background: rgba(0,0,0,0.87);
      position: absolute;
      top: calc(50% - 1px);
      margin-left: 8px;
      opacity: .3;
    }
  }
}

.timeline {
  background-color: #111215;
  color: #fff;
  padding: 24px 0px;
  header {
    margin:0;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    position: relative;
    span {
      color: #FFFFFF;	font-family: Archia;	font-size: 12.19px;	letter-spacing: 2px;	line-height: 16px;
      text-transform: uppercase;
      &:first-child {
        margin-right: 12px;
      }
      &:last-child {
        margin-left: 12px;
      }
    }
    .spacer {
      flex:1;
      &:after {
        content: '';
        position: relative;
        display: inline-block;
        height: 1px;
        width: 100%;
        background-color: #666;
        z-index: 50;
        bottom: 5px;
      }
    }
  }

    footer {
    margin:0;
    margin-top: 86px;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    position: relative;
    @media(max-width: 700px) {
      margin-top: 16px;
    } 
    span {
      color: #FFFFFF;	font-family: Archia;	font-size: 12.19px;	letter-spacing: 2px;	line-height: 16px;
      text-transform: uppercase;
      &:first-child {
        margin-right: 12px;
      }
      &:last-child {
        margin-left: 12px;
      }
    }
    .spacer {
      flex:1;
      &:after {
        content: '';
        position: relative;
        display: inline-block;
        height: 1px;
        width: 100%;
        background-color: transparent;
        border-bottom: 1px dashed #666;
        z-index: 50;
        bottom: 5px;
      }
    }
  }
  .wrap {
    padding: 0 16px;
  }
}

ul {
  display: flex;
  justify-content: space-around;
  padding: 0 124px;
  margin:0;
  position: relative;
  top: -9px;
              @media (max-width: 700px) {
              flex-direction: column;
              padding: 96px 16px 16px;
      }
  li {
    flex:1;
    display: inline-flex;
    flex-direction: column;
    padding-top: 127px;
    position: relative;
                @media (max-width: 700px) {
              flex-direction: row;
              padding-top: 0;
              padding-left: 27px;
              margin-bottom: 48px;
      }
    &:before {
      content: '';
      display: block;
      left:0;
      top:0;
      height: 127px;
      width: 1px;
      position: absolute;
      background: #666;
                    @media (max-width: 700px) {
                      width: 27px;
                      height: 1px;
                      top: 5px;
                    }
    }
    span {
      margin-top: 20px;
      margin-bottom: 20px;
      color: rgba(7,176,255,0.6);	font-family: Archia;	font-size: 12.19px;	letter-spacing: 2px;	line-height: 16px;
      @media(max-width: 700px) {
        position: relative;
        left: -16px;
      }
    }
  }

  .step {
    margin-bottom: 20px;
    color: #FFFFFF;	font-family: Archia;	font-size: 16.32px;	font-weight: 600;	letter-spacing: 0.2px;	line-height: 20px;
    &:last-child {
      margin-bottom:0;
    }
  }
}

.detail {
  @media(max-width: 700px) {
    padding-top: 0px;
  }
}
</style>
